import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import { Provider } from 'react-redux';
import store from "./store";
import { TonConnectUIProvider } from '@tonconnect/ui-react';


import { Buffer } from "buffer";
window.Buffer = window.Buffer || Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <Provider store={store}>
      <React.StrictMode>
          <BrowserRouter>
              <TonConnectUIProvider manifestUrl="https://tgapp.investorium.org/tonconnect-manifest.json">
                  <App />
              </TonConnectUIProvider>
          </BrowserRouter>
      </React.StrictMode>
    </Provider>
);

